import React from 'react';
import { Helmet } from 'react-helmet';
import { Header, Title, ContainerHeader } from '../components/Header';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Logout from '../components/Logout';
import {ReactComponent as Logo} from '../images/logo.svg';
import PropTypes from 'prop-types';
import useConfig from '../hooks/useConfig';

const HeaderContainer = ({title = ""}) => {
	const config = useConfig();

    return (
        <div style={{backgroundColor: "#32CD32"}}>		
            <Helmet>
				<title>App Ventas - {title}</title>
			</Helmet>

			<Header>
				<ContainerHeader>
					<Title>{title}</Title>
					<Logo />
					<Navbar expand="lg" >
						<Container>
							<Navbar.Brand href="/">{config && config[0]?.name} </Navbar.Brand>
							<Navbar.Toggle aria-controls="basic-navbar-nav" />
							<Navbar.Collapse id="basic-navbar-nav">
								<Nav className="me-auto">
									<Nav.Link href="/sales">Ventas</Nav.Link>
									<Nav.Link href="/expenses">Gastos</Nav.Link>
									<Nav.Link href="/reports">Reportes</Nav.Link>
									<Nav.Link href="/monthlyPayments">Apartados</Nav.Link>
									<Nav.Link href="/orders">Pedidos</Nav.Link>
									<Nav.Link href="/config">Configuración</Nav.Link>
									<Nav.Link href="#" ><Logout/></Nav.Link>
								</Nav>
							</Navbar.Collapse>
						</Container>
					</Navbar>
				</ContainerHeader>
			</Header>
        </div>
    );
}

// Define the expected prop types 
HeaderContainer.propTypes = { title: PropTypes.string.isRequired, };

export default HeaderContainer;